import React from 'react';

const LoginArrow = ({ className }) => (
    <svg
        width='371'
        height='186'
        viewBox='0 0 371 186'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <path
            d='M367.653 83.182C367.639 83.2323 367.624 83.2821 367.607 83.3334C367.334 84.1284 366.627 84.6763 365.953 85.1767C349.099 97.7375 329.055 111.909 310.351 121.463C253.764 150.37 183.358 153.563 124.32 130.303C103.708 122.181 84.4319 110.507 67.8034 95.8211C59.7176 88.6807 52.1118 80.0534 45.4729 71.2071C38.9869 62.5619 32.3946 52.0676 25.9297 42.7638C25.7757 42.5433 25.4135 42.6408 25.3173 42.8932C24.2 45.8421 17.1587 58.2184 16.5358 59.1003C13.7382 63.0646 9.88654 61.6167 11.8266 56.608C14.1092 50.7155 16.5483 46.0927 19.3623 40.5288C20.3059 38.6609 21.8987 34.4986 23.7206 33.4778C25.8781 32.2695 28.4024 33.2698 30.8254 33.7472C36.2839 34.8187 42.541 35.7103 47.8511 37.5063C52.7458 39.1626 56.4157 45.1043 48.1319 43.3996C42.7122 42.2837 36.6601 41.0218 31.2673 39.5919C31.0708 39.5389 30.9161 39.7568 31.0333 39.923C33.6305 43.6075 37.8119 50.4489 39.7798 53.9004C70.7963 108.312 143.516 139.941 205.661 139.968C217.827 139.974 229.996 139.051 242.024 137.195C285.893 130.425 329.245 105.857 359.579 82.8032C361.061 81.6773 362.445 80.1951 364.292 80.0191C366.087 79.8481 368.093 81.4724 367.653 83.182Z'
            fill='#EDC880'
        />
    </svg>
);

export { LoginArrow };
